import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MomentModule } from 'ngx-moment';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
// import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { Ng1MessageDetailsReportComponentWrapperDirective } from '../../hybrid/upgraded-directives';
import { MissedRecallReportFilterComponent } from './missed-recall-report-filter.component';
import { MissedRecallReportTableComponent } from './missed-recall-report-table.component';
import { MissedRecallReportComponent } from './missed-recall-report.component';
import { MissedRecallAction } from './state/missed-recall-action.service';
import { MissedRecallSelectors } from './state/missed-recall-selectors.service';
import { MissedRecallEffect } from './state/missed-recall.effect';
import { missedRecallReportStateReducer, STORE_FEATURE_KEY_MISSED_RECALL } from './state/missed-recall.reducer';

@NgModule({
    declarations: [
        MissedRecallReportTableComponent,
        MissedRecallReportFilterComponent,
        MissedRecallReportComponent,
        Ng1MessageDetailsReportComponentWrapperDirective
    ],
    imports: [
        CommonModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_MISSED_RECALL, missedRecallReportStateReducer),
        EffectsModule.forFeature([ MissedRecallEffect ]),
        TableModule,
        ButtonModule,
        TooltipModule,
        CalendarModule,
        // TabViewModule, // TODO: Consider if we should switch to PrimeNG with router outlet
        BsDatepickerModule.forRoot(),
        TabsModule.forRoot(),
        MomentModule,
        TranslateModule
    ],
    providers: [
        MissedRecallAction,
        MissedRecallSelectors,
        DatePipe
    ]
})
export class MissedRecallReportModule {
}
